import React from 'react'

const ITRProfitAndLossUI = ({ pnlList }) =>
  <div id='itrPnL' className='g_m_top_200'>
    <span className='g_large'><b>Profit and Loss</b></span>
    <table className='g_table'>
      <thead className='g_sticky'><tr><td />
        {
          pnlList.map((pnl, i) =>
            <td key={i} className='g_text_right'>
              <b className='g_no_wrap'>{pnl.financialYear}</b>
            </td>
          )
        }
      </tr></thead>
      <tbody>
        <RowUI pnlList={pnlList} name='saleOfGoods' />
        <RowUI pnlList={pnlList} name='saleOfServices' />
        <RowUI pnlList={pnlList} name='receiptsFromProfession' />
        <RowUI pnlList={pnlList} name='otherOperatingIncome' />
        <RowUI pnlList={pnlList} total={true} name='revenueFromOperations' />
        <RowUI pnlList={pnlList} name='openingInventories' />
        <RowUI pnlList={pnlList} name='closingInventories' />
        <RowUI pnlList={pnlList} name='purchases' />
        <RowUI pnlList={pnlList} name='factoryOverheads' />
        <RowUI pnlList={pnlList} name='directWages' />
        <RowUI pnlList={pnlList} name='directExpenses' />
        <RowUI pnlList={pnlList} name='otherDirectCosts' />
        <RowUI pnlList={pnlList} total={true} name='grossProfit' />
        <RowUI pnlList={pnlList} name='freightOutward' />
        <RowUI pnlList={pnlList} name='consumptionOfStoresAndSpareParts' />
        <RowUI pnlList={pnlList} name='powerAndFuel' />
        <RowUI pnlList={pnlList} name='employeeBenefitExpenses' />
        <RowUI pnlList={pnlList} name='sellingGeneralAndAdministrativeExpenses' />
        <RowUI pnlList={pnlList} name='sellingPromotionalAdvertisementExpenses' />
        <RowUI pnlList={pnlList} name='otherExpenses' />
        <RowUI pnlList={pnlList} total={true} name='totalExpenses' />
        <RowUI pnlList={pnlList} total={true} name='eBITDA' />
        <RowUI pnlList={pnlList} name='depreciationAndAmortization' />
        <RowUI pnlList={pnlList} total={true} name='eBIT' />
        <RowUI pnlList={pnlList} name='financeCost' />
        <RowUI pnlList={pnlList} total={true} name='profitAfterInterestAndBeforeTax' />
        <RowUI pnlList={pnlList} name='otherNonOperatingIncome' />
        <RowUI pnlList={pnlList} name='otherNonOperatingExpense' />
        <RowUI pnlList={pnlList} total={true} name='profitBeforeTax' />
        <RowUI pnlList={pnlList} name='currentTax' />
        <RowUI pnlList={pnlList} name='deferredTax' />
        <RowUI pnlList={pnlList} total={true} name='profitAfterTax' />
        <RowUI pnlList={pnlList} total={true} name='retainedProfit' />
      </tbody>
    </table>
  </div>

const RowUI = ({ pnlList, total, name }) =>
  <tr className={total && 'g_table_total'}>
    <td><Desc name={name} /></td>
    {
      pnlList.map((pnl, i) =>
        <td key={i} className='g_text_right'>
          {pnl[name]}
        </td>
      )
    }
  </tr>

const Desc = ({ name }) =>
  <span>
    {(() => {
      switch (name) {
        case 'saleOfGoods':
          return 'Sale of Goods'
        case 'saleOfServices':
          return 'Sale of Services'
        case 'receiptsFromProfession':
          return 'Receipts from Profession'
        case 'otherOperatingIncome':
          return 'Other Operating Income'
        case 'revenueFromOperations':
          return 'Revenue from Operations'
        case 'openingInventories':
          return 'Opening Inventories'
        case 'closingInventories':
          return 'Closing Inventories'
        case 'purchases':
          return 'Purchases'
        case 'factoryOverheads':
          return 'Factory Overheads'
        case 'directWages':
          return 'Direct Wages'
        case 'directExpenses':
          return 'Direct Expenses'
        case 'otherDirectCosts':
          return 'Other Direct Costs'
        case 'grossProfit':
          return 'Gross Profit'
        case 'freightOutward':
          return 'Freight Outward'
        case 'consumptionOfStoresAndSpareParts':
          return 'Consumption of Stores and Spare Parts'
        case 'powerAndFuel':
          return 'Power and Fuel'
        case 'employeeBenefitExpenses':
          return 'Employee Benefit Expenses'
        case 'sellingGeneralAndAdministrativeExpenses':
          return 'Selling General and Administrative Expenses'
        case 'sellingPromotionalAdvertisementExpenses':
          return 'Selling Promotional/Advertisement Expenses'
        case 'otherExpenses':
          return 'Other Expenses'
        case 'totalExpenses':
          return 'Total Expenses'
        case 'eBITDA':
          return 'EBITDA'
        case 'depreciationAndAmortization':
          return 'Depreciation and Amortization'
        case 'eBIT':
          return 'EBIT'
        case 'financeCost':
          return 'Finance Cost'
        case 'profitAfterInterestAndBeforeTax':
          return 'Profit after Interest and before Tax'
        case 'otherNonOperatingIncome':
          return 'Other Non Operating Income'
        case 'otherNonOperatingExpense':
          return 'Other Non Operating Expense'
        case 'profitBeforeTax':
          return 'Profit Before Tax'
        case 'currentTax':
          return 'Current Tax'
        case 'deferredTax':
          return 'Deferred Tax'
        case 'profitAfterTax':
          return 'Profit after Tax'
        case 'retainedProfit':
          return 'Retained Profit'
        default:
          return name
      }
    })()}
  </span>

export default ITRProfitAndLossUI
